import React from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.css';

/**
 * Footer for the groups page: logo and tagline, the contact e-mail, then copyright and the
 * organisation number.
 * @returns {JSX.Element} Site footer
 */
function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  const email = t('contact.email');

  return (
    <footer className="site-footer">
      <div className="site-footer-content">
        <div>
          <img src="/revetall-logo.svg" alt="Revetall" className="site-footer-logo" />
          <p className="site-footer-tagline">{t('footer.tagline')}</p>
        </div>

        <div className="site-footer-contact">
          <p className="site-footer-heading">{t('footer.contactTitle')}</p>
          <a href={`mailto:${email}`}>{email}</a>
        </div>
      </div>

      <div className="site-footer-bottom">
        <p className="site-footer-copy">{t('footer.copyright', { year })}</p>
        <p className="site-footer-copy">{t('footer.orgNumber')}</p>
      </div>
    </footer>
  );
}

export default Footer;
